import React from "react";
import Dialog from "../../components/Dialogs/Dialog";
import Button from "../../components/Button";
import {OptionBasicMYCopyConflictDto} from "../../services/Client";
import {Icon, Form, Flag, TextArea, Checkbox} from "semantic-ui-react";
import Collapsible from "react-collapsible";
import i18n from "../../i18n";
import _ from "lodash";
import {translate} from "react-i18next";

interface IBaseOptionsMYCopyConflictDialogProps {
    /** Close dialog and pass the selected arguments. */
    onConfirm: (sourceOBForOverwrite: OptionBasicMYCopyConflictDto[]) => any;

    /** Close dialog without return value. */
    onClose: () => any;

    /** The lists with conflicts between source and target contexts. */
    copyConflictList: OptionBasicMYCopyConflictDto[];
}

interface IBaseOptionsMYCopyConflictDialogState {
    sourceOBDataForOverwrite: Map<number, OptionBasicMYCopyConflictDto>;

}

class BaseOptionsMYCopyConflictDialog extends React.Component<IBaseOptionsMYCopyConflictDialogProps, IBaseOptionsMYCopyConflictDialogState> {
    constructor(props: IBaseOptionsMYCopyConflictDialogProps) {
        super(props);

        this.state = {
            sourceOBDataForOverwrite: new Map()
        };
    }

    private handleOnOverwriteClick(obConflict: OptionBasicMYCopyConflictDto) {
        let newStateSource = _.cloneDeep(this.state.sourceOBDataForOverwrite);
        if (newStateSource.has(obConflict.sourceOBSimple.objectId)) {
            newStateSource.delete(obConflict.sourceOBSimple.objectId);
        } else {
            newStateSource.set(obConflict.sourceOBSimple.objectId, obConflict);
        }

        this.setState({sourceOBDataForOverwrite: newStateSource});
    }

    private handleConfirm = () => {
        if (!this.props.onConfirm) {
            return;
        }

        this.props.onConfirm(Array.from(this.state.sourceOBDataForOverwrite.values()));
    }

    render() {
        const obsInConflict = this.props.copyConflictList.length > 0 ?
            this.props.copyConflictList.filter(ob => ob.foundOBInTarget && ob.targetOBSimple && !ob.obInitialized && !ob.wfStarted) : [];
        const obsInitialized = this.props.copyConflictList.length > 0 ? this.props.copyConflictList.filter(ob => ob.foundOBInTarget && ob.obInitialized) : [];
        const obsWFStarted = this.props.copyConflictList.length > 0 ? this.props.copyConflictList.filter(ob => ob.foundOBInTarget && ob.wfStarted) : [];
        const obsWithDuplicate = this.props.copyConflictList.length > 0
            ? this.props.copyConflictList.filter(ob => ob.sourceDuplicate || ob.targetDuplicate)
            : [];

        return (
            <Dialog
                open={true}
                title={i18n.t("BASEOPTIONS:OB_MY_COPY_CONFLICT_DLG_TITLE")}
                customStyleClassName={"myBaseOptionsCopyDialog"}
                actions={
                    [
                        <Button
                            key={"submitButton"}
                            icon={"checkmark"}
                            onClick={this.handleConfirm}
                        />,
                        <Button
                            key={"cancelButton"}
                            icon={"ban"}
                            onClick={this.props.onClose}
                        />
                    ]
                }
            >

                {/** OBs that have a match in the target context that can be oerwritten */}
                {obsInConflict.length > 0 &&
                    <div className={"collapsible"}>
                        <Collapsible
                            open={true}
                            trigger={
                                <h4 style={{'backgroundColor': 'whitesmoke'}}>
                                    <Icon name='exclamation' color='red' size='large' />
                                    {i18n.t("BASEOPTIONS:OB_COPY_OVERWRITE_TITLE")}
                                    <Icon name='angle double down' size='small' style={{float: 'right'}} />
                                </h4>}
                        >
                            <div className={"overwriteMessageMYCopyOB"}>{i18n.t("BASEOPTIONS:OB_COPY_OVERWRITE_MSG")}</div>
                            <br />
                            <br />
                            <div className={"contextTitle"}>
                                <div className={"sourceBlock"}>
                                    {i18n.t("BASEOPTIONS:SOURCE_CONTEXT")}
                                </div>
                                <div className={"targetBlock"}>
                                    {i18n.t("BASEOPTIONS:TARGET_CONTEXT")}
                                </div>
                            </div>
                            <div>
                                {obsInConflict.map((obC, obCIndex) => (
                                    <React.Fragment key={'ob-conflict-' + obCIndex}>
                                        <br />
                                        <div className={"conflictBlock"}>
                                            <div className={"sourceBlock"}>
                                                <br />
                                                <div onClick={() => this.handleOnOverwriteClick(obC)}>
                                                    <Checkbox
                                                        label={
                                                            <label>
                                                                <span>
                                                                    {i18n.t("BASEOPTIONS:OPTION_CODE") + ': '}
                                                                    <span className="obIdentifierCopyConflict">
                                                                        {obC.sourceOBSimple.optionCode}
                                                                        &nbsp;&nbsp;&nbsp;
                                                                    </span>
                                                                    {i18n.t("BASEOPTIONS:OPTION_TYPE") + ': '}
                                                                    <span className="obIdentifierCopyConflict">
                                                                        {obC.sourceOBSimple.optionType}
                                                                        &nbsp;&nbsp;&nbsp;
                                                                    </span>
                                                                    {i18n.t("BASEOPTIONS:MODELYEAR") + ': '}
                                                                    <span className="obIdentifierCopyConflict">
                                                                        {obC.sourceOBSimple.modelyear.mj4}
                                                                    </span>
                                                                </span>
                                                            </label>
                                                        }
                                                    />
                                                </div>

                                                <div className="OBTextForm">
                                                    <br />
                                                    <Form>
                                                        {obC.sourceOBSimple.texts.sort((a, b) =>
                                                            (a.languageDto && b.languageDto && a.languageDto.code > b.languageDto.code) ? 1 : -1
                                                        ).map((item, index) =>
                                                            <Form.Group widths='equal' key={obCIndex + "formGroupSource" + index}>
                                                                <Form.Field
                                                                    key={obCIndex + "formField" + index}
                                                                    readOnly={true}
                                                                    label={<p>{i18n.t("COLUMN_FACTORY:SHORTTEXT")}
                                                                        <Flag
                                                                            className="copyMYOBTextLangFlag"
                                                                            name={item.languageDto && item.languageDto.code === "de" ? "de" : "gb"}
                                                                        />
                                                                    </p>}
                                                                    control={TextArea}
                                                                    value={item.shorttext || ""}
                                                                />
                                                            </Form.Group>
                                                        )}
                                                    </Form>
                                                    <br />
                                                </div>
                                            </div>
                                            <div className={"targetBlock"}>
                                                <br />
                                                <span>
                                                    {i18n.t("BASEOPTIONS:OPTION_CODE") + ': '}
                                                    <span className="obIdentifierCopyConflict">
                                                        {obC.targetOBSimple && obC.targetOBSimple.optionCode}
                                                        &nbsp;&nbsp;&nbsp;
                                                    </span>
                                                    {i18n.t("BASEOPTIONS:OPTION_TYPE") + ': '}
                                                    <span className="obIdentifierCopyConflict">
                                                        {obC.targetOBSimple && obC.targetOBSimple.optionType}
                                                        &nbsp;&nbsp;&nbsp;
                                                    </span>
                                                    {i18n.t("BASEOPTIONS:MODELYEAR") + ': '}
                                                    <span className="obIdentifierCopyConflict">
                                                        {obC.targetOBSimple && obC.targetOBSimple.modelyear.mj4}
                                                    </span>
                                                </span>
                                                <div className="OBTextForm">
                                                    <br />
                                                    <Form>
                                                        {obC.targetOBSimple && obC.targetOBSimple.texts.sort((a, b) =>
                                                            (a.languageDto && b.languageDto && a.languageDto.code > b.languageDto.code) ? 1 : -1)
                                                            .map((item, index) =>
                                                                <Form.Group widths='equal' key={obCIndex + "formGroupTarget" + index}>
                                                                    <Form.Field
                                                                        key={obCIndex + "formField" + index}
                                                                        readOnly={true}
                                                                        label={<p>{i18n.t("COLUMN_FACTORY:SHORTTEXT")}
                                                                            <Flag
                                                                                className="copyMYOBTextLangFlag"
                                                                                name={item.languageDto && item.languageDto.code === "de" ? "de" : "gb"}
                                                                            />
                                                                        </p>}
                                                                        control={TextArea}
                                                                        value={item.shorttext || ""}
                                                                    />
                                                                </Form.Group>
                                                            )}
                                                    </Form>
                                                    <br />
                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                ))}
                            </div>
                        </Collapsible>
                    </div>
                }

                {obsInitialized.length > 0 && obsInConflict.length > 0 && <hr />}
                {obsInitialized.length > 0 && obsInConflict.length > 0 && <br />}
                {/** OBs that cannot be copied because they already exist in target context and are assigned to at least a PSL */}
                {obsInitialized.length > 0 &&
                    <div className={"collapsible"}>
                        <Collapsible
                            open={true}
                            trigger={
                                <h4 style={{'backgroundColor': 'whitesmoke'}}>
                                    <Icon name='ban' color='red' size='small' />
                                    {i18n.t("BASEOPTIONS:OB_COPY_ALREADY_INIT_TITLE")}
                                    <Icon name='angle double down' size='small' style={{float: 'right'}} />
                                </h4>}
                        >
                            <div style={{'backgroundColor': 'whitesmoke'}}>{i18n.t("BASEOPTIONS:OB_COPY_ALREADY_INIT_MSG")}</div>
                            <br />
                            <div>
                                {obsInitialized.map((obInit, obInitIndex) => (
                                    <div key={'ob-initialized-' + obInitIndex}>
                                        <br />
                                        {i18n.t("BASEOPTIONS:OPTION_CODE") + ': '}
                                        <span className="obIdentifierCopyConflict">
                                            {obInit.sourceOBSimple.optionCode}
                                            &nbsp;&nbsp;&nbsp;
                                        </span>
                                        {i18n.t("BASEOPTIONS:OPTION_TYPE") + ': '}
                                        <span className="obIdentifierCopyConflict">
                                            {obInit.sourceOBSimple.optionType}
                                            &nbsp;&nbsp;&nbsp;
                                        </span>
                                        {i18n.t("BASEOPTIONS:MODELYEAR") + ': '}
                                        <span className="obIdentifierCopyConflict">
                                            {obInit.sourceOBSimple.modelyear.mj4}
                                        </span>
                                        <div className="OBTextForm">
                                            <br />
                                            <Form>
                                                <Form.Group widths='equal' key={obInitIndex + "formGroup"}>
                                                    {obInit.sourceOBSimple.texts.sort((a, b) =>
                                                        (a.languageDto && b.languageDto && a.languageDto.code > b.languageDto.code) ? 1 : -1)
                                                        .map((item, index) =>
                                                            <Form.Field
                                                                key={obInitIndex + "formField" + index}
                                                                readOnly={true}
                                                                label={<p>{i18n.t("COLUMN_FACTORY:SHORTTEXT")}
                                                                    <Flag
                                                                        className="copyMYOBTextLangFlag"
                                                                        name={item.languageDto && item.languageDto.code === "de" ? "de" : "gb"}
                                                                    />
                                                                </p>}
                                                                control={TextArea}
                                                                value={item.shorttext || ""}
                                                            />
                                                        )}
                                                </Form.Group>
                                            </Form>
                                            <br />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Collapsible>
                    </div>
                }

                {obsWFStarted.length > 0 && (obsInConflict.length > 0 || obsInitialized.length > 0) && <hr />}
                {obsWFStarted.length > 0 && (obsInConflict.length > 0 || obsInitialized.length > 0) && <br />}
                {/** OBs that cannot be copied because they already exist in target context and their workflow is already started */}
                {obsWFStarted.length > 0 &&
                    <div className={"collapsible"}>
                        <Collapsible
                            open={true}
                            trigger={
                                <h4 style={{'backgroundColor': 'whitesmoke'}}>
                                    <Icon name='ban' color='red' size='small' />
                                    {i18n.t("BASEOPTIONS:OB_COPY_WF_STARTED_TITLE")}
                                    <Icon name='angle double down' size='small' style={{float: 'right'}} />
                                </h4>}
                        >
                            <div style={{'backgroundColor': 'whitesmoke'}}>{i18n.t("BASEOPTIONS:OB_COPY_WF_STARTED_MSG")}</div>
                            <br />
                            <div>
                                {obsWFStarted.map((obWF, obWFIndex) => (
                                    <div key={'ob-wf-started-' + obWFIndex}>
                                        <br />
                                        {i18n.t("BASEOPTIONS:OPTION_CODE") + ': '}
                                        <span className="obIdentifierCopyConflict">
                                            {obWF.sourceOBSimple.optionCode}
                                            &nbsp;&nbsp;&nbsp;
                                        </span>
                                        {i18n.t("BASEOPTIONS:OPTION_TYPE") + ': '}
                                        <span className="obIdentifierCopyConflict">
                                            {obWF.sourceOBSimple.optionType}
                                            &nbsp;&nbsp;&nbsp;
                                        </span>
                                        {i18n.t("BASEOPTIONS:MODELYEAR") + ': '}
                                        <span className="obIdentifierCopyConflict">
                                            {obWF.sourceOBSimple.modelyear.mj4}
                                        </span>
                                        <div className="OBTextForm">
                                            <br />
                                            <Form>
                                                <Form.Group widths='equal' key={obWFIndex + "formGroup"}>
                                                    {obWF.sourceOBSimple.texts.sort((a, b) => (a.languageDto && b.languageDto && a.languageDto.code > b.languageDto.code) ? 1 : -1)
                                                        .map((item, index) =>
                                                            <Form.Field
                                                                key={obWFIndex + "formField" + index}
                                                                readOnly={true}
                                                                label={<p>{i18n.t("COLUMN_FACTORY:SHORTTEXT")}
                                                                    <Flag
                                                                        className="copyMYOBTextLangFlag"
                                                                        name={item.languageDto && item.languageDto.code === "de" ? "de" : "gb"}
                                                                    />
                                                                </p>}
                                                                control={TextArea}
                                                                value={item.shorttext || ""}
                                                            />
                                                        )}
                                                </Form.Group>

                                            </Form>
                                            <br />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Collapsible>
                    </div>
                }
                {obsWithDuplicate.length > 0 && (obsInConflict.length > 0 || obsInitialized.length > 0 || obsWFStarted.length > 0) && <hr />}
                {obsWithDuplicate.length > 0 && (obsInConflict.length > 0 || obsInitialized.length > 0 || obsWFStarted.length > 0) && <br />}
                {/** OBs that cannot be copied because they have duplicates in source or target context */}
                {obsWithDuplicate.length > 0 &&
                    <div className={"collapsible"}>
                        <Collapsible
                            title={i18n.t("BASEOPTIONS:OB_DUPLICATE_TITLE")}
                            open={true}
                            trigger={
                                <h4 style={{'backgroundColor': 'whitesmoke'}}>
                                    <Icon name='ban' color='red' size='small' />
                                    {i18n.t("BASEOPTIONS:OB_DUPLICATE_TITLE")}
                                    <Icon name='angle double down' size='small' style={{float: 'right'}} />
                                </h4>}
                        >
                            <div style={{'backgroundColor': 'whitesmoke'}}>{i18n.t("BASEOPTIONS:OB_DUPLICATE_MSG")}</div>
                            <br />
                            <div>
                                {obsWithDuplicate.map((obWF, obWFIndex) => (
                                    <div key={'ob-duplicate-' + obWFIndex}>
                                        <br />
                                        {i18n.t("BASEOPTIONS:OPTION_CODE") + ': '}
                                        <span className="obIdentifierCopyConflict">
                                            {obWF.sourceOBSimple.optionCode}
                                            &nbsp;&nbsp;&nbsp;
                                        </span>
                                        {i18n.t("BASEOPTIONS:OPTION_TYPE") + ': '}
                                        <span className="obIdentifierCopyConflict">
                                            {obWF.sourceOBSimple.optionType}
                                            &nbsp;&nbsp;&nbsp;
                                        </span>
                                        {i18n.t("BASEOPTIONS:MODELYEAR") + ': '}
                                        <span className="obIdentifierCopyConflict">
                                            {obWF.sourceOBSimple.modelyear.mj4}
                                        </span>
                                        <div className="OBTextForm">
                                            <br />
                                            <Form>
                                                <Form.Group widths='equal' key={obWFIndex + "formGroup"}>
                                                    {obWF.sourceOBSimple.texts.sort((a, b) => (a.languageDto && b.languageDto && a.languageDto.code > b.languageDto.code) ? 1 : -1)
                                                        .map((item, index) =>
                                                            <Form.Field
                                                                key={obWFIndex + "formField" + index}
                                                                readOnly={true}
                                                                label={<p>{i18n.t("COLUMN_FACTORY:SHORTTEXT")}
                                                                    <Flag
                                                                        className="copyMYOBTextLangFlag"
                                                                        name={item.languageDto && item.languageDto.code === "de" ? "de" : "gb"}
                                                                    />
                                                                </p>}
                                                                control={TextArea}
                                                                value={item.shorttext || ""}
                                                            />
                                                        )}
                                                </Form.Group>

                                            </Form>
                                            <br />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Collapsible>
                    </div>
                }
            </Dialog>
        );
    }
}

export default translate(["BASEOPTIONS", "COLUMN_FACTORY"])(BaseOptionsMYCopyConflictDialog);



// WEBPACK FOOTER //
// ./src/views/BaseOptionsView/BaseOptionsMYCopyConflictDialog.tsx